<template>
  <HeaderView v-if="!$route.meta.hideHeader" />
  <router-view />
</template>

<script>
import HeaderView from "@/components/Molecules/Header.vue";

export default {
  components: {
    HeaderView,
  },
  watch: {
    $route(to) {
      document.title = to.meta.title || "";
    },
  },
};
</script>

<style>
/*
 * Lulu Rewards design tokens.
 * Promoted from the auth pages + success page so the registration flow
 * (and any future page) consume a single source of truth instead of
 * re-typing the same gradients and colour values.
 */
:root {
  --lulu-primary: rgb(0, 109, 62);
  --lulu-primary-dark: rgb(0, 85, 48);
  --lulu-primary-soft: rgba(0, 109, 62, 0.08);
  --lulu-primary-border: rgba(0, 109, 62, 0.25);
  --lulu-bg-gradient: linear-gradient(160deg, #f0faf5 0%, #e6f4ee 100%);
  --lulu-header-gradient: linear-gradient(135deg, rgb(0, 109, 62) 0%, rgb(0, 85, 48) 100%);
  /* Brand CTA gradient - same direction/stops as the header gradient, kept
     as a separate token because some surfaces (success-page button) may
     diverge later without affecting page headers. */
  --lulu-cta-gradient: linear-gradient(135deg, rgb(0, 109, 62) 0%, rgb(0, 85, 48) 100%);
  --lulu-card-shadow: 0 8px 40px rgba(0, 109, 62, 0.12);
  --lulu-card-shadow-hover: 0 6px 20px rgba(0, 109, 62, 0.35);
  --lulu-btn-shadow: 0 4px 16px rgba(0, 109, 62, 0.25);
  --lulu-text-strong: #1a202c;
  --lulu-text-muted: #718096;
  --lulu-text-subtle: #a0aec0;
  --lulu-border: #e2e8f0;
  --lulu-surface-soft: #f7fafc;
  --lulu-surface: #ffffff;
  --lulu-radius-card: 20px;
  --lulu-radius-input: 10px;
  /* Inline link colour - currently identical to --lulu-primary but kept
     as a named purpose token so link styling can shift independently. */
  --lulu-link: rgb(0, 109, 62);
  /* Warning / pending tokens - promoted from the dashboard activation
     banner so any future warning surface stays visually consistent. */
  --lulu-warning-soft: rgba(245, 158, 11, 0.12);
  --lulu-warning-border: #fbbf24;
  --lulu-warning-strong: #b45309;
  --lulu-warning-text: #92651b;
  /* Danger tokens - promoted from the M5 dashboard surfaces so the
     destructive colour is consistent (status badges, danger buttons,
     inline error text) and tunable in one place. */
  --lulu-danger: #e53e3e;
  --lulu-danger-soft: rgba(229, 62, 62, 0.08);
  --lulu-danger-border: rgba(229, 62, 62, 0.4);
  --lulu-danger-strong: #b91c1c;
  /* Neutral surface token - used for low-emphasis role pills (Employee)
     and any other element that needs a calm, non-brand fill. */
  --lulu-surface-muted: #edf2f7;
}

body {
  font-family: 'Roboto', sans-serif;
}
</style>
